

//From Actions i want to call to services
import * as BasicSearchConstants from './BasicSearchConstants';
import AppService from 'Global/AppService';
import { AUTH_OBJECT_KEY_NAME, GENERIC_ERROR_MESSAGE, ROUTE_DASHBOARD, ROUTE_HOME } from 'Common/constants/commonConstants';
import { AxiosService } from 'Common/services/AxiosService';
import { addDeviceToPowerBIReducerState } from 'PowerBI/store/PowerBIAction';
import { addDeviceToInstrumentKPIReducerState } from 'InstrumentKPI/store/InstrumentKPIAction';
import { addDeviceToInstrumentConnReducerState } from 'Instrument/subfeatures/PerformanceMonitor/InstrumentConnectivity/InstrumentConnectivityActions';
import { addDeviceToInstrumentTestsReducerState } from 'Instrument/subfeatures/PerformanceMonitor/InstrumentTests/InstrumentTestsActions';
import { addDeviceToInstrumentUptimeReducerState } from 'Instrument/subfeatures/PerformanceMonitor/InstrumentUptime/InstrumentUptimeAction';
import { addDeviceToDTReducerState } from 'DrillThrough/store/DrillThroughAction';
import { addDeviceToSystemReducerState } from 'Instrument/subfeatures/System/SystemAction';
import { addDeviceToIncidentReducerState } from 'Instrument/subfeatures/Incidents/IncidentsAction'
import { addDeviceToCalAssaySummReducerState } from 'Instrument/subfeatures/CalibrationAssaySummary/CalAssaySummAction';
import { addDeviceToQCAssaySummReducerState } from 'Instrument/subfeatures/QCAssaySummary/QCAssaySummAction';
import { addDeviceToCalibrationReducerState } from 'Instrument/subfeatures/Calibration/CalibrationAction'
import { addDeviceToSampleStatsReducerState } from 'Instrument/subfeatures/SampleStatistics/SampleStatisticsAction';
import { addDeviceToRBReducerState } from 'Instrument/subfeatures/ReagentBlank/RBAction';
import { rateLimitErrorHandler } from 'Common/components/GenericErrorHandler';
import { serializeError } from 'Common/utils/Utils';

const searchDevice = (url, payload, instanceId) => {

	return (dispatch) => {
		dispatch(searchDeviceFetchRequest());

		dispatch(addDeviceToPowerBIReducerState(instanceId));
		dispatch(addDeviceToInstrumentKPIReducerState(instanceId));
		dispatch(addDeviceToInstrumentConnReducerState(instanceId));
		dispatch(addDeviceToInstrumentTestsReducerState(instanceId));
		dispatch(addDeviceToInstrumentUptimeReducerState(instanceId));
		dispatch(addDeviceToDTReducerState(instanceId));
		dispatch(addDeviceToSystemReducerState(instanceId));
		dispatch(addDeviceToIncidentReducerState(instanceId));
		dispatch(addDeviceToCalAssaySummReducerState(instanceId));
		dispatch(addDeviceToQCAssaySummReducerState(instanceId));
		dispatch(addDeviceToCalibrationReducerState(instanceId));
		dispatch(addDeviceToSampleStatsReducerState(instanceId));
		dispatch(addDeviceToRBReducerState(instanceId));

		function callback(success, err) {
			if (success) {
				if (success.result && success.result.length > 0) {
					dispatch(searchDeviceFetchSuccess(success));
				} else {
					dispatch(searchDeviceFetchFailure());
				}
			} else {
				switch (err.status) {
					case 403: {
						if (err.responseText && err.responseText.includes("Gateway")) {
							rateLimitErrorHandler();
						} else {
							dispatch(searchDeviceAccessDeniedAction(true))
						}
						break;
					}
					case 404:
					default:
						dispatch(searchDeviceFetchFailure(err.data));
				}
			}
		};
		AxiosService.postData(url, payload, callback, { [AUTH_OBJECT_KEY_NAME]: instanceId });
	}
}

const fetchDeviceHeartBeat = (url, inputHeader) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_HEART_BEAT_FETCH_REQUEST });
		function callback(success, err) {
			if (success) {
				if (success.result && success.result.length > 0) {
					dispatch(fetchDeviceHeartBeatSuccess(success));
				}
			}
		}
		AppService.getData(url, callback, inputHeader);
	}
}

const fetchDeviceDemographics = (url, inputHeader) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_REQUEST });
		function callback(success, err) {
			if (success && success.result && success.result.length > 0) {
				dispatch(fetchDeviceDemographicsSuccess(success));
			} else {
				dispatch({ type: BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_FAILURE });
			}
		}
		AppService.getData(url, callback, inputHeader);
	}
}

const fetchRecentRunAssayForCalibrationAndQC = (url, instanceId) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_REQUEST, payload: instanceId });

		function callback(success, err) {
			if (success && success.result) {
				dispatch(fetchcalqcsucccess({ ...success, instanceId }));
			} else {
				dispatch({ type: BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_FAILURE, payload: instanceId });
			}
		}
		AppService.getData(url, callback);
	}
}


const fetchLatestLotAllassay = (url, instanceId) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_REQUEST, payload: instanceId });

		function callback(success, err) {
			if (success && success.result) {
				dispatch(fetchcalall({ ...success, instanceId }));
			} else {
				dispatch({ type: BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_FAILURE, payload: instanceId });
			}
		}
		AppService.getData(url, callback);
	}
}

const fetchRecentDateTimeForMetrics = (url, instanceId) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_REQUEST, payload: instanceId });

		function callback(success, err) {
			if (success && success.result) {
				dispatch(fetchRecentDateTimeForMetricsSuccess({ ...success, instanceId }));
			} else {
				dispatch({ type: BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_FAILURE, payload: instanceId })
			}
		}
		AppService.getData(url, callback);
	}
}

const fetchEventDetailsForDevice = (payload, url, instanceId, requestedPageSize, fetchNext) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_REQUEST, payload: { instanceId, fetchNext } });
		function callback(success, err) {
			if (success && success !== "") {
				dispatch({ type: BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_SUCCESS, payload: { instanceId, newState: success.result, requestedPageSize, fetchNext } });
			} else {
				dispatch({ type: BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_FAILURE, payload: { instanceId, newState: err.responseJSON } })
			}
		}
		AppService.postData(payload, url, callback, { [AUTH_OBJECT_KEY_NAME]: instanceId });
	}
}

const fetchcalqcsucccess = (result) => {
	return { type: BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_SUCCESS, payload: result };
}

const fetchcalall = (result) => {
	return { type: BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_SUCCESS, payload: result };
}

const fetchDeviceDemographicsSuccess = (result) => {
	return { type: BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_SUCCESS, newState: result };
}
const fetchDeviceHeartBeatSuccess = (result) => {
	return { type: BasicSearchConstants.DEVICE_HEART_BEAT_FETCH_SUCCESS, newState: result };
}
const searchDeviceFetchSuccess = (result) => {
	return { type: BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_SUCCESS, newState: result };
}
const searchDeviceFetchFailure = (error) => {
	return { type: BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_FAILURE, error: error };
}
const searchDeviceAccessDeniedAction = (val) => {
	return { type: BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_ACCESS_DENIED, newItem: val };
}
const searchDeviceFetchRequest = () => {
	return { type: BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_REQUEST };
}

const resetNoDeviceFound = () => {
	return { type: BasicSearchConstants.BASIC_DEVICE_SEARCH_RESET_NO_DATA_FOUND };
}

const fetchRecentDateTimeForMetricsSuccess = (result) => {
	return { type: BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_SUCCESS, payload: result }
}

const showFileAccessModal = (instanceId, showModal) => {
	return { type: BasicSearchConstants.FILE_ACCESS_MODAL_CONTROL, payload: { instanceId, showModal } };
}

const fetchAllowedModelsForMetering = (url) => {
	return (dispatch) => {
		dispatch(fetchAllowedModelsForMeteringRequest());

		function callback(success, err) {
			if (success && success.result) {
				dispatch(fetchAllowedModelsForMeteringSuccess(success.result));
			} else {
				dispatch(fetchAllowedModelsForMeteringError(err));
			}
		}

		AppService.getData(url, callback);
	}
}

const fetchAllowedModelsForMeteringRequest = () => {
	return {
		type: BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_REQUEST
	};
};

const fetchAllowedModelsForMeteringSuccess = (result) => {
	return {
		type: BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_SUCCESS,
		payload: result,
	};
};

const fetchAllowedModelsForMeteringError = (err) => {
	return {
		type: BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_FAILURE,
		payload: serializeError(err),
	};
};

const updateDeviceMeteringStatus = (url, payload) => {
	return (dispatch) => {
		dispatch(updateDeviceMeteringStatusRequest(payload.instanceId));

		function callback(success, err) {
			if (success && success.result) {
				dispatch(updateDeviceMeteringStatusSuccess(payload?.metered, payload?.instanceId));
			} else {
				dispatch(updateDeviceMeteringStatusFailure(payload?.instanceId));
			}
		}

		AppService.putData(payload, url, callback);
	}
}

const updateDeviceMeteringStatusRequest = (instanceId) => {
	return {
		type: BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_REQUEST,
		payload: { instanceId }
	};
};

const updateDeviceMeteringStatusSuccess = (result, instanceId) => {
	return {
		type: BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_SUCCESS,
		payload: { instanceId, result },
	};
};

const updateDeviceMeteringStatusFailure = (instanceId) => {
	return {
		type: BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_FAILURE,
		payload: { instanceId, error: GENERIC_ERROR_MESSAGE },
	};
};

const fetchTriggerActivity = (url,instanceId) => {
	return (dispatch) => {
		function callback(success, err) {
			if (success) {
				dispatch(updateTriggerActivity(instanceId, success?.result?? 0));
			} 
		}

		AppService.getData(url, callback);
	}
}

const updateTriggerActivity = (instanceId, result) => {
	return {
		type: BasicSearchConstants.FETCH_TRIGGER_ACTIVITY,
		payload: {instanceId,result},
	};
};

const fetchTriggerAuditCount = (url,instanceId) => {
	return (dispatch) => {
		function callback(success, err) {
			if (success) {
				dispatch(updateTriggerAuditCount(instanceId, success?.result?? 0));
			} 
		}

		AppService.getData(url, callback);
	}
}

const updateTriggerAuditCount = (instanceId, result) => {
	return {
		type: BasicSearchConstants.FETCH_TRIGGER_AUDIT_COUNT,
		payload: {instanceId,result},
	};
};

const fetchSupportedFeaturesForModel = (url, instanceId) => {
	return (dispatch) => {
		dispatch({ type: BasicSearchConstants.GET_SUPPORTED_FEATURES_REQUEST, payload: instanceId });

		function callback(success) {
			if (success) {
				if (success.result) {
					dispatch({
						type: BasicSearchConstants.GET_SUPPORTED_FEATURES_SUCCESS,
						payload: { instanceId, result : success.result }
					});
				}
			} else {
				dispatch({ type: BasicSearchConstants.GET_SUPPORTED_FEATURES_FAILURE, payload: instanceId })
			}
		}
		AppService.getData(url, callback);
	}
}


export {
	searchDevice,
	resetNoDeviceFound,
	fetchDeviceHeartBeat,
	fetchDeviceDemographics,
	searchDeviceAccessDeniedAction,
	fetchRecentRunAssayForCalibrationAndQC,
	fetchLatestLotAllassay,
	fetchRecentDateTimeForMetrics,
	showFileAccessModal,
	fetchEventDetailsForDevice,
	fetchAllowedModelsForMetering,
	updateDeviceMeteringStatus,
	fetchTriggerActivity,
	fetchTriggerAuditCount,
	fetchSupportedFeaturesForModel,
	clearInstrumentInstance
}

function clearInstrumentInstance(instanceId) {
	return { type: BasicSearchConstants.CLEAR_INSTRUMENT_INSTANCE, instanceId };
}